/**
 * RAKİP AVLARI — rakip-özel iki backlink avı (DFS ücretli, elle tetik):
 *   1) Link mıknatısı: rakibin en çok farklı domain'den link almış sayfaları
 *      ("ne yazarsam link kazanırım" listesi)
 *   2) Kırık ama link almış: rakibin backlink'i olan ölü sayfaları
 *      (aynı konuyu yazıp o linkleri sahiplenme — broken link building)
 * Backlink Ajanı'ndan Backlink Fırsat Ajanı'na taşındı (Çekidüzen: fırsat işleri tek yerde).
 */
import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

// Kodlu URL'ler (/ar/%D8...) okunur gösterilir; çözülemezse olduğu gibi kalır
const okunurYol = (u: string) => {
  const yol = u.replace(/^https?:\/\/[^/]+/, "") || "/";
  try { return decodeURIComponent(yol); } catch { return yol; }
};

export function BacklinkAvlari({ domainId }: { domainId: number }) {
  const [rakip, setRakip] = useState("");
  const [sonuc, setSonuc] = useState<null | { rakip: string; linkbait: { hata: string | null; sayfalar: { url: string; referringDomains: number; backlinks: number }[] }; kirik: { hata: string | null; sayfalar: { url: string; statusCode: number | null; referringDomains: number; backlinks: number }[] } }>(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const getir = async () => {
    if (!rakip.trim() || yukleniyor) return;
    setYukleniyor(true);
    try {
      const r = await fetch(`/api/domains/${domainId}/backlink-firsatlar?rakip=${encodeURIComponent(rakip.trim())}`);
      const j = await r.json();
      if (!r.ok) { alert(j.error ?? "Alınamadı"); return; }
      setSonuc(j);
    } catch { alert("Bağlantı hatası"); }
    finally { setYukleniyor(false); }
  };
  return (
    <Card><CardContent className="p-4">
      <div className="mb-1 text-sm font-semibold">🎣 Rakip Avları <span className="text-[11px] font-normal text-muted-foreground">— link kazanan içerikleri + backlink'i olan kırık sayfaları</span></div>
      <p className="mb-2 text-[11.5px] text-muted-foreground">Rakip domain gir: (1) en çok domain'den link almış sayfaları göster — "ne yazarsam link kazanırım" listesi; (2) backlink'i olan ama KIRIK sayfalarını göster — aynı konuyu yazıp o linkleri sahiplenme (broken link building) fırsatı.</p>
      <div className="mb-3 flex gap-2">
        <input value={rakip} onChange={(e) => setRakip(e.target.value)} placeholder="rakip.com" spellCheck={false}
          onKeyDown={(e) => { if (e.key === "Enter") void getir(); }}
          className="h-9 w-64 rounded-lg border border-gray-200 bg-transparent px-3 text-[13px] outline-none focus:border-brand-300 dark:border-gray-800 dark:text-white/90 dark:placeholder:text-gray-500" />
        <Button size="sm" disabled={yukleniyor || !rakip.trim()} onClick={() => void getir()} className="gap-1.5">{yukleniyor ? "Getiriliyor…" : "Fırsatları Getir"}</Button>
      </div>
      {sonuc && (
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <div>
            <div className="mb-1.5 text-[12.5px] font-semibold">Link mıknatısı içerikleri ({sonuc.rakip})</div>
            {sonuc.linkbait.hata ? <p className="text-[12px] text-red-500">{sonuc.linkbait.hata.includes("balance") || sonuc.linkbait.hata.includes("Money") ? "DataForSEO bakiyesi yetersiz — bakiye yüklenince çalışır." : sonuc.linkbait.hata}</p>
            : sonuc.linkbait.sayfalar.length === 0 ? <p className="text-[12px] text-muted-foreground">5+ domain'den link almış sayfa bulunamadı.</p>
            : sonuc.linkbait.sayfalar.map((x) => (
              <div key={x.url} className="flex items-center justify-between gap-2 border-b border-gray-50 py-1 text-[12px] dark:border-gray-800/60">
                <a href={x.url} target="_blank" rel="noopener noreferrer" className="truncate text-brand-600 hover:underline" title={x.url}>{okunurYol(x.url)}</a>
                <span className="shrink-0 tabular-nums text-muted-foreground">{x.referringDomains} domain · {x.backlinks} link</span>
              </div>
            ))}
          </div>
          <div>
            <div className="mb-1.5 text-[12.5px] font-semibold">Kırık ama link almış sayfalar</div>
            {sonuc.kirik.hata ? <p className="text-[12px] text-red-500">{sonuc.kirik.hata.includes("balance") || sonuc.kirik.hata.includes("Money") ? "DataForSEO bakiyesi yetersiz — bakiye yüklenince çalışır." : sonuc.kirik.hata}</p>
            : sonuc.kirik.sayfalar.length === 0 ? <p className="text-[12px] text-muted-foreground">Backlink'li kırık sayfa bulunamadı.</p>
            : sonuc.kirik.sayfalar.map((x) => (
              <div key={x.url} className="flex items-center justify-between gap-2 border-b border-gray-50 py-1 text-[12px] dark:border-gray-800/60">
                <span className="truncate" title={x.url}>{okunurYol(x.url)}</span>
                <span className="shrink-0 tabular-nums text-muted-foreground">{x.statusCode ?? "?"} · {x.referringDomains} domain</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </CardContent></Card>
  );
}
